import { theme } from "../theme";

interface DomunIconProps {
  svgClass?: string;
  svgColor?: string;
  svgWidth?: number;
  svgHeight?: number;
}

const DomunIcon = ({
  svgColor,
  svgHeight,
  svgWidth,
  svgClass,
}: DomunIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={svgWidth ?? 40}
    height={svgHeight ?? 41}
    fill="none"
    className={svgClass ?? ""}
  >
    <path
      fill={svgColor ?? theme.colors.accentGreenScale.g8}
      d="M38.045 16.49 23.862 2.3a5.668 5.668 0 0 0-8.017 0L1.66 16.49a5.673 5.673 0 0 0 0 8.022L15.843 38.7a5.668 5.668 0 0 0 8.017 0l14.183-14.188a5.674 5.674 0 0 0 0-8.021h.002ZM21.97 30.3a5.882 5.882 0 1 1 .098-8.036l1.414 1.36c.775.632 2.335 1.584 4.442.783l-5.954 5.892v.002Zm2.049-7.65a156.292 156.292 0 0 1-7.2-7.239c-1.877-2.461-.412-6.6 2.71-7.086 1.705-.267 2.907.178 4.172 1.266a412.53 412.53 0 0 0 6.404 6.418c3.872 4.591-1.976 10.03-6.086 6.641Z"
    />
  </svg>
);
export default DomunIcon;
